module.exports = __webpack_public_path__ + "img/brandguide_typecolors.cd9bbfb7.jpg";